import type {ReactElement} from 'react';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {Modal} from '@Components/modal';
import {LazyPanel} from '@Components/lazy-panel';
import {CheckoutHostProvider} from '@Components/checkout-flow/components/checkout-host-provider/checkout-host-provider';
import {useCheckoutModalDimensions} from '@Components/checkout-flow/checkout-flow.hooks';
import {RESUBSCRIBE_CONFIRMATION_MODAL_DIMENSIONS} from '@Modals/resubscribe-confirmation-modal/resubscribe-confirmation-modal.types';

export default function ResubscribeConfirmationModal(): ReactElement {
  const modalId = MODALS_IDS.RESUBSCRIBE_CONFIRMATION_MODAL;
  const panelId = `${modalId}-panel`;
  const {width, height} = useCheckoutModalDimensions(RESUBSCRIBE_CONFIRMATION_MODAL_DIMENSIONS);

  return (
    <Modal modalId={modalId} panelId={panelId} modalHeight={height} modalWidth={width}>
      <CheckoutHostProvider modalId={modalId} panelId={panelId}>
        <LazyPanel panelDirectoryName="resubscribe-confirmation-panel" panelProps={{panelId}} />
      </CheckoutHostProvider>
    </Modal>
  );
}

export const openResubscribeConfirmationModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.RESUBSCRIBE_CONFIRMATION_MODAL,
      panelProps: {},
    })
  );
};
